import { observer } from "mobx-react-lite";
import { useState } from "react";
import { runInAction } from "mobx";
import { useOrderFormState } from "@boundary/_hooks/useOrderFormState";
import { Input } from "@boundary/components/input";
import { isValidRange } from "@boundary/utils/pageRange";
import { useDebouncedPriceCalculation } from "@boundary/_hooks/useDebouncedPriceCalculation";
import styles from "./pagesSelect.module.scss";

interface PagesSelectProps {
  vm: ReturnType<typeof useOrderFormState>;
}

export const PagesSelect = observer(function PagesSelect({ vm }: PagesSelectProps) {
  if (!vm.currentFile || !vm.currentService) return null;
  if (!vm.currentFile.id || !vm.currentFile.previewUrl || !vm.currentFile.totalPages) return null;

  if (vm.currentService.type !== "document_print") return null;

  const file = vm.currentFile;
  const [error, setError] = useState<string>("");
  const calculatePrice = useDebouncedPriceCalculation(vm);

  const handleChange = (value: string) => {
    runInAction(() => {
      file.pagesRange = value;
    });
    const validationError = isValidRange(value, file.totalPages);
    if (!validationError) {
      runInAction(() => {
        file.pagesRangeValid = value;
      });
      calculatePrice();
    }
    setError(validationError || "");
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>Диапазон страниц</h2>
      <Input
        placeholder={`Например: 1-3,5 (1-${file.totalPages})`}
        value={file.pagesRange || ""}
        onChange={(e) => handleChange(e.target.value)}
      />
      {error && <p className={styles.error}>{error}</p>}
    </div>
  );
});

